import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { festivalActions } from '../../../redux/actions/festival-action';
import ReactTable from "react-table";

import 'react-table/react-table.css';
import {
  Grid,
  Row,
  Col,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";

import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { savePagination, getSavedPagination } from '../../../helper/helperFunctions';
var moment = require("moment");
const queryString = require('query-string');

class FestivalMusicDirectorAllListPage extends React.Component {
  constructor(props){
    super(props);
      let AdminUserStorage = JSON.parse(localStorage.getItem('admin-user'));
      const { savedPage, savedPageSize } = getSavedPagination("festivalMusicDirector");
      const parsed = queryString.parse(window.location.search);
      // console.log('AdminUserStorage', AdminUserStorage);
      this.state = {
          sorted    :'',
          filtered  :'',
          savedPage: parsed.restore_page ? savedPage : 0,
          savedPageSize: parsed.restore_page ? savedPageSize : 10,
          companyId :this.props.userAdmin.user.company_id,
          AdminUserStorageToken : AdminUserStorage.token
      };
      this.festivalPaginationData  = this.festivalPaginationData.bind(this);
      this.filterSearchHandle     = this.filterSearchHandle.bind(this);
  }
 	componentDidMount() {
    const { savedPage, savedPageSize } = this.state;
    this.props.getFestivalAllMusicDirectorsCall(savedPage + 1, [], "", this.state.companyId, savedPageSize);
	}


  filterSearchHandle(e){
      this.setState({
          'filtered': e.target.value
      });
  }
  
  festivalPaginationData(page, filter, sort, pageSize){
    this.props.getFestivalAllMusicDirectorsCall(page, filter, sort, this.state.companyId, pageSize);
  }
	getFormattedDateTime = (date, format) => {
		if (!date) {
			console.error("Invalid performance date");
			return '';
		}
		
		// Use moment.js to parse and format the date
		const momentDate = moment(date, 'YYYY-MM-DD HH:mm:ss');
		if (!momentDate.isValid()) {
			console.error("Invalid date format");
			return '';
		}
		return momentDate.format(format);
	};
	getFormattedTime = (date, format) => {
		if (!date) {
			console.error("Invalid performance date");
			return '';
		}
		
		// Use moment.js to parse and format the date
		const momentDate = moment(date, 'HH:mm:ss');
		if (!momentDate.isValid()) {
			console.error("Invalid date format");
			return '';
		}
		return momentDate.format(format);
	};
  onFetchData = (state) => {
    savePagination("festivalMusicDirector", state.page, state.pageSize);
    this.setState({
			savedPage: state.page,
			savedPageSize: state.pageSize
		})
    var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
    state.pageData(state.page+1, state.filtered, sort, state.pageSize);
  };
  
  render(){
        const { festivalAllMusicDirectorsData,festivalAllMusicDirectorsPages,loading, adminType,userAdmin  } = this.props;
        const { filtered } = this.state;
        const columns = [
            {
                Header:"Festival Music Directors Listing",
                columns: [
                    {
                        Header: "Name",
                        accessor: "name",
                        className: "action-center"
                        
                    },
                    {
                        Header: "Email",
                        accessor: "email",
                        className: "action-center"
                        
                    },
                    {
                        Header: "School Name",
                        accessor: "school",
                        className: "action-center"
                    },
                    {
                        Header: "Group Name",
                        accessor: "school_name",
                        className: "action-center"
                    },
                    {
                        Header: "Date",
                        accessor: "date",
                        className: "action-center",
                        Cell: ({value}) => (
                          <div>
                             <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Date</Tooltip>}>
                                <span>{value ? this.getFormattedDateTime(value, 'MM/DD/YY') : ''}</span>
                              </OverlayTrigger>
                          </div>
                        ),
                    },
                    {
                        Header: "Time",
                        accessor: "time",
                        className: "action-center",
                        Cell: ({value}) => (
                          <div>
                             <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Time</Tooltip>}>
                                <span>{value ? this.getFormattedTime(value, 'hh:mm A') : ''}</span>
                              </OverlayTrigger>
                          </div>
                        ),
                    },
                    {
                        Header: "Order",
                        accessor: "order",
                        className: "action-center",
                        Cell: ({value}) => (
                          <div>
                             <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Order</Tooltip>}>
                                <span>{value != '0' ? value : ''}</span>
                              </OverlayTrigger>
                          </div>
                        ),
                    },
                    {
                        Header: "Festival",
                        accessor: "festival",
                        className: "action-center",
                        Cell : ({value}) => (
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival {adminType ==='company'?'edit':'view'}</Tooltip>}>
                            <Link to={'/Admin/Edit-Festival/'+value.id+'?Music-directors'} >{value.name}</Link>
                          </OverlayTrigger>
                        )
                    },
                    {
                      Header: "Actions",
                      accessor: "id",
                      Cell: ({value}) => (
                        <div>
                           <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Music Director Festival Performance</Tooltip>}>
                              <Link to={'/Admin/MD-media/'+value+'?Festival/Music-directors'} className="action-button-size"><i className="fa fa-youtube-play" /></Link>
                            </OverlayTrigger>
                        </div>
                      ),
                      className: "action-center",
                      sortable:false,
                      show:true
                  }
                ]
            }
        ];
    return(
            <div className="content">
                <Grid fluid>
                  <Row>
                    <Col md={12}>
                      <Card
                        title="Festivals Music Directors List"
                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                                <Row>
                                  
                                    <Col md={8}>
                                      
                                    </Col>
                                  
                                    
                                    <Col md={4} sm={6} xs={12}>
                                      <div >
                                        <FormInputs
                                          ncols={["col-md-12"]}
                                          onChange={this.filterSearchHandle}
                                          proprieties={[
                                            {
                                              type: "text",
                                              bsClass: "form-control",
                                              placeholder: "Seach Festival Music Directors",
                                              onChange:this.filterSearchHandle,
                                              name:"filter"
                                            }

                                          ]}
                                        />
                                      </div>
                                    </Col>
                                </Row>
                            </Grid>
                            {
                              adminType && userAdmin && 
                              <ReactTable
                                  
                                  data={festivalAllMusicDirectorsData}
                                  pages={festivalAllMusicDirectorsPages} 
                                  loading = {loading}
                                  columns={columns}
                                  filtered={filtered}
                                  page={this.state.savedPage}
																	pageSize={this.state.savedPageSize}
                                  className="striped hover"
                                  pageData = {this.festivalPaginationData}
                                  manual
                                  onFetchData={this.onFetchData}
                                  // onFetchData={(state, instance) => {
                                  //     savePagination("festivalMusicDirector", state.page, state.pageSize);
                                  //     var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
                                  //     state.pageData(state.page+1, state.filtered, sort, state.pageSize);
                                  // }}
                              />
                            }
                            
                          </div>
                        }
                      />
                    </Col>
                  </Row>
                </Grid>
            </div>
      
    );
  };
}

const mapDispatchToProps = dispatch => {
  return ({
    getFestivalAllMusicDirectorsCall  : (page, filter, sort, companyId, pageSize) => { dispatch(festivalActions.getFestivalsAllMusicDirectorsPagination(page, filter, sort, companyId, pageSize)) },
  });
};

function mapStateToProps(state) {
    const { festivalAllMusicDirectorsData,festivalAllMusicDirectorsPages,loading } = state.festivalReducer;
    const { adminType, userAdmin } = state.adminReducer;
    return {
        festivalAllMusicDirectorsData,festivalAllMusicDirectorsPages,loading,adminType, userAdmin
    };
}

const FestivalMusicDirectorAllList = connect(mapStateToProps, mapDispatchToProps)(FestivalMusicDirectorAllListPage);

export default FestivalMusicDirectorAllList;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalMusicDirector/FestivalMusicDirectorAllList.jsx